import { useCallback } from 'react';

import clientConfig from '../../client/config';

export default function useStravaAuth(callbackUrl: string) {
  return useCallback(() => {
    const {
      strava: { clientID, scope, authUrl, callbackDomain },
      baseUri,
    } = clientConfig;

    const url = callbackDomain
      ? callbackUrl.replace(baseUri, callbackDomain)
      : callbackUrl;

    const responseType = 'code';
    const encodedCallbackUrl = encodeURIComponent(url);

    window.location.href = `${authUrl}?client_id=${clientID}&redirect_uri=${encodedCallbackUrl}&response_type=${responseType}&scope=${scope}`;
  }, [callbackUrl]);
}
